import axios from "axios";

const client = axios.create({
  baseURL: process.env.NODE_ENV == "production" ? "" : "/api",
  json: true
});

export default {
  async execute(method, resource, data) {
    // inject the accessToken for each request
    // let accessToken = await Vue.prototype.$auth.getAccessToken()
    let obj = {
        method,
        url: resource,
        data
        //   headers: {
        //     Authorization: `Bearer ${accessToken}`
        //   }
      }
    if(method == 'get' && data){
        obj = Object.assign(obj,{params:data})
    }
    return client(obj).then(req => {
      console.log('a',req.status)
      return req.data;
    }).catch(e=>{
      console.log(e.data)
      return Promise.reject(e.response)
    })
  },
  getCodes(data) {
    return this.execute("get", "/codes",data);
  },
  getCode(id) {
    return this.execute("get", `/codes/${id}`);
  },
  createCode(data) {
    return this.execute("post", "/codes", data);
  },
  updateCode(id, data) {
    return this.execute("put", `/codes/${id}`, data);
  },
  deleteCode(id) {
    return this.execute("delete", `/codes/${id}`);
  },
  login(data) {
    return this.execute("post", `/authenticate`, data);
  },
  isLoggedin() {
    return this.execute("get", `/isAuthenticated`);
  },
  logout(){
    return this.execute("get", `/logout`);
  },
  register(data) {
    return this.execute("post", `/register`, data);
  },
  forgotPassword(data) {
    return this.execute("post", "/forgotpassword", data);
  },
  resetPassword(data) {
    return this.execute("post", "/resetpassword", data);
  },
  post(url,data){
    return this.execute("post", url, data);
  }
};



// WEBPACK FOOTER //
// ./src/api.js